module.exports = __webpack_public_path__ + "static/media/home.71a1f542.svg";